/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_PictureInputs */

const en_admin_resources_picture = /** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

const de_admin_resources_picture = /** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild`)
};

const es_admin_resources_picture = /** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagen`)
};

const fr_admin_resources_picture = /** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

const nl_admin_resources_picture = /** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afbeelding`)
};

/** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */
const it_admin_resources_picture = en_admin_resources_picture;

/** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */
const pt_br2_admin_resources_picture = en_admin_resources_picture;

/** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */
const pl_admin_resources_picture = en_admin_resources_picture;

/** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */
const hu_admin_resources_picture = en_admin_resources_picture;

/** @type {(inputs: Admin_Resources_PictureInputs) => LocalizedString} */
const ro_admin_resources_picture = en_admin_resources_picture;

/**
* | output |
* | --- |
* | "Image" |
*
* @param {Admin_Resources_PictureInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_picture = /** @type {((inputs?: Admin_Resources_PictureInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_PictureInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_picture(inputs)
	if (locale === "de") return de_admin_resources_picture(inputs)
	if (locale === "es") return es_admin_resources_picture(inputs)
	if (locale === "fr") return fr_admin_resources_picture(inputs)
	if (locale === "nl") return nl_admin_resources_picture(inputs)
	if (locale === "it") return it_admin_resources_picture(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_picture(inputs)
	if (locale === "pl") return pl_admin_resources_picture(inputs)
	if (locale === "hu") return hu_admin_resources_picture(inputs)
	return ro_admin_resources_picture(inputs)
});
export { admin_resources_picture as "admin.resources.picture" }